import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { cerrarSesion, obtenerCuentaActual } from "../api";
import Entrar from "../paginas/Entrar";

export default function Layout() {
  const qc = useQueryClient();
  const navegar = useNavigate();
  const sesion = useQuery({ queryKey: ["cuenta"], queryFn: obtenerCuentaActual });

  const salir = useMutation({
    mutationFn: cerrarSesion,
    onSuccess: () => {
      qc.clear();
      navegar("/");
    },
  });

  if (sesion.isPending) {
    return (
      <main className="shell">
        <p className="muted">Cargando…</p>
      </main>
    );
  }

  // Sin sesión no hay layout: la pantalla de entrada ocupa todo.
  if (!sesion.data) return <Entrar />;

  const c = sesion.data;
  const esCuradorOAdmin = c.esCurador || c.esAdministrador;

  return (
    <div className="layout-contenedor">
      <header className="barra">
        <div className="barra-contenido">
          <div className="barra-marca-wrap">
            <Link to="/" className="marca">
              <span className="marca-icono">🐾</span>
              <span className="marca-texto">Fichas Veterinarias</span>
            </Link>
            <nav className="nav-escritorio" aria-label="Navegación principal">
              <NavLink
                to="/"
                end
                className={({ isActive }) => `nav-enlace ${isActive ? "activo" : ""}`}
              >
                Mis mascotas
              </NavLink>
              <NavLink
                to="/perfil"
                className={({ isActive }) => `nav-enlace ${isActive ? "activo" : ""}`}
              >
                Mi perfil
              </NavLink>
              {esCuradorOAdmin && (
                <NavLink
                  to="/datos"
                  className={({ isActive }) => `nav-enlace ${isActive ? "activo" : ""}`}
                >
                  Catálogo y Datos
                </NavLink>
              )}
              {c.esAdministrador && (
                <NavLink
                  to="/admin"
                  className={({ isActive }) => `nav-enlace ${isActive ? "activo" : ""}`}
                >
                  Administración
                </NavLink>
              )}
            </nav>
          </div>
          <div className="barra-fin">
            <Link
              to="/perfil"
              className="usuario usuario-link"
              title={`Mi perfil (${c.email})`}
              style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "0.4rem" }}
            >
              <span className="usuario-nombre" style={{ color: "var(--ink)" }}>👤 {c.nombre}</span>
              {esCuradorOAdmin && (
                <span className="etiqueta neutra usuario-rol">
                  {c.rolGlobal}
                </span>
              )}
            </Link>
            <button
              type="button"
              className="boton-salir"
              onClick={() => salir.mutate()}
              disabled={salir.isPending}
              title="Cerrar sesión"
            >
              {salir.isPending ? "Saliendo…" : "Salir"}
            </button>
          </div>
        </div>
      </header>

      <main className="shell">
        <Outlet />
      </main>

      {/* Barra de navegación inferior exclusiva para móviles */}
      <nav className="nav-movil" aria-label="Navegación rápida móvil">
        <NavLink
          to="/"
          end
          className={({ isActive }) => `nav-movil-item ${isActive ? "activo" : ""}`}
        >
          <span className="nav-movil-icono">🐾</span>
          <span className="nav-movil-texto">Mascotas</span>
        </NavLink>
        <NavLink
          to="/mascotas/nueva"
          className={({ isActive }) => `nav-movil-item ${isActive ? "activo" : ""}`}
        >
          <span className="nav-movil-icono">➕</span>
          <span className="nav-movil-texto">Nueva</span>
        </NavLink>
        <NavLink
          to="/perfil"
          className={({ isActive }) => `nav-movil-item ${isActive ? "activo" : ""}`}
        >
          <span className="nav-movil-icono">👤</span>
          <span className="nav-movil-texto">Mi Perfil</span>
        </NavLink>
        {esCuradorOAdmin && (
          <NavLink
            to="/datos"
            className={({ isActive }) => `nav-movil-item ${isActive ? "activo" : ""}`}
          >
            <span className="nav-movil-icono">📦</span>
            <span className="nav-movil-texto">Catálogo</span>
          </NavLink>
        )}
        {c.esAdministrador && (
          <NavLink
            to="/admin"
            className={({ isActive }) => `nav-movil-item ${isActive ? "activo" : ""}`}
          >
            <span className="nav-movil-icono">⚙️</span>
            <span className="nav-movil-texto">Admin</span>
          </NavLink>
        )}
      </nav>
    </div>
  );
}
